var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _computeSpacing, computeSpacing_fn;
import { LitElement } from "@horizon/base";
import { property } from "@horizon/base/decorators.js";
import { unsafeStatic, html } from "@horizon/base/static-html.js";
import InlineStyles from "./inline.css.js";
import {
  inlineTags
} from "../types.js";
import { classMap } from "@horizon/base/directives";
class HznInline extends LitElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _computeSpacing);
    this.space = "base";
    this.as = "div";
    this.alignY = "center";
    this.alignX = "start";
    this.reverse = false;
    this.wrap = false;
  }
  render() {
    const { column, row } = __privateMethod(this, _computeSpacing, computeSpacing_fn).call(this);
    return html`<${unsafeStatic(this.as && inlineTags.includes(this.as) ? this.as : "div")}
      class=${classMap({
      inline: true,
      "is-reversed": Boolean(this.reverse),
      "is-wrapped": Boolean(this.wrap),
      "is-column-gap-none": column === "none",
      "is-column-gap-xxsmall": column === "xxsmall",
      "is-column-gap-xsmall": column === "xsmall",
      "is-column-gap-small": column === "small",
      "is-column-gap-base": column === "base",
      "is-column-gap-medium": column === "medium",
      "is-column-gap-large": column === "large",
      "is-column-gap-xlarge": column === "xlarge",
      "is-column-gap-xxlarge": column === "xxlarge",
      "is-column-gap-xxxlarge": column === "xxxlarge",
      "is-row-gap-none": row === "none",
      "is-row-gap-xxsmall": row === "xxsmall",
      "is-row-gap-xsmall": row === "xsmall",
      "is-row-gap-small": row === "small",
      "is-row-gap-base": row === "base",
      "is-row-gap-medium": row === "medium",
      "is-row-gap-large": row === "large",
      "is-row-gap-xlarge": row === "xlarge",
      "is-row-gap-xxlarge": row === "xxlarge",
      "is-row-gap-xxxlarge": row === "xxxlarge",
      "is-collapse-below-small": this.collapseBelow === "small",
      "is-collapse-below-medium": this.collapseBelow === "medium",
      "is-collapse-below-large": this.collapseBelow === "large",
      "is-collapse-below-xlarge": this.collapseBelow === "xlarge",
      "is-collapse-below-xxlarge": this.collapseBelow === "xxlarge",
      "is-align-x-stretch": this.alignX === "stretch",
      "is-align-x-start": this.alignX === "start",
      "is-align-x-center": this.alignX === "center",
      "is-align-x-end": this.alignX === "end",
      "is-align-x-between": this.alignX === "between",
      "is-align-x-around": this.alignX === "around",
      "is-align-x-evenly": this.alignX === "evenly",
      "is-align-y-stretch": this.alignY === "stretch",
      "is-align-y-start": this.alignY === "start",
      "is-align-y-center": this.alignY === "center",
      "is-align-y-end": this.alignY === "end",
      "is-align-y-baseline": this.alignY === "baseline"
    })}>
      <slot></slot>
    </${unsafeStatic(this.as && inlineTags.includes(this.as) ? this.as : "div")}>`;
  }
}
_computeSpacing = new WeakSet();
computeSpacing_fn = function() {
  const spacing = {
    row: "base",
    column: "base"
  };
  if (this.space) {
    const spaceSplit = this.space.split(" ");
    if (spaceSplit.length > 1) {
      spacing.column = spaceSplit[0];
      spacing.row = spaceSplit[1];
    } else {
      spacing.column = spacing.row = spaceSplit[0];
    }
  }
  return spacing;
};
HznInline.styles = [InlineStyles];
__decorateClass([
  property({ type: String })
], HznInline.prototype, "space", 2);
__decorateClass([
  property({ type: String })
], HznInline.prototype, "as", 2);
__decorateClass([
  property({ type: String, attribute: "collapse-below" })
], HznInline.prototype, "collapseBelow", 2);
__decorateClass([
  property({ type: String, attribute: "align-y" })
], HznInline.prototype, "alignY", 2);
__decorateClass([
  property({ type: String, attribute: "align-x" })
], HznInline.prototype, "alignX", 2);
__decorateClass([
  property({ type: Boolean })
], HznInline.prototype, "reverse", 2);
__decorateClass([
  property({ type: Boolean, attribute: "wrap" })
], HznInline.prototype, "wrap", 2);
export {
  HznInline
};
//# sourceMappingURL=inline.js.map
